var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"orderPackHoldTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'orderPacking.put_on_hold' | translate}}</b> | {{model.trackingId}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<h3>Order Pack Hold</h3>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>{{ 'common.ok' | translate }}\n</button>\n</div>\n</form>";
var id1="orderPackHold.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/common/ui/modal/templates/orderPackHold.html
// module id = 2577
// module chunks = 1